import React from "react";
import {
    StripeProvider,
    CardElement,
    Elements,
    injectStripe
} from "react-stripe-elements";

class _PaymentForm extends React.Component {
    constructor(props) {
        super(props);
        this.handleChange = this.handleChange.bind(this);
    }

    handleChange(evt) {
        console.log("change", evt);
        if (this.props.handleChange) {
            this.props.handleChange(evt);
        }

        if (evt.complete) {
            this.props.handleComplete(this.props.stripe);
        } else if (evt.error) {
            this.props.handleError(evt.error);
        } else {
            this.props.handleComplete(false);
        }
    }
    render() {
        let style = {
            base: {
                fontSize: "14px",
                color: "#424770",
                letterSpacing: "0.025em",
                fontFamily: "Light-45, Arial",
                "::placeholder": {
                    color: "#aab7c4"
                }
            },
            invalid: {
                color: "#9e2146"
            }
        };

        return (
            <CardElement
                hidePostalCode={true}
                onBlur={handleBlur}
                onChange={this.handleChange}
                onFocus={handleFocus}
                onReady={handleReady}
                style={style}
            />
        );
    }
}

const PaymentForm = injectStripe(_PaymentForm);

const elementsFonts = [
    {
        family: "Light-45",
        src:
            window.location.protocol == "https:"
                ? `url(${require("../../fonts/Light-45.woff2")})`
                : null,
        style: "normal"
    }
];

const handleBlur = () => {
    console.log("[blur]");
};
const handleChange = change => {
    console.log("[change]", change);
};
const handleClick = () => {
    console.log("[click]");
};
const handleFocus = () => {
    console.log("[focus]");
};
const handleReady = () => {
    console.log("[ready]");
};

const StripeCardElement = props => {
    if (!global.Stripe) {
        return null;
    }
    return (
        <StripeProvider apiKey={props.stripePublishableKey}>
            <Elements fonts={elementsFonts}>
                <PaymentForm
                    handleComplete={props.handleComplete}
                    handleChange={props.handleChange}
                    handleError={props.handleError}
                />
            </Elements>
        </StripeProvider>
    );
};

export default StripeCardElement;
